import { API_BASE } from '../config';
import { getAccessToken } from '../core/auth/tokenUtil';
import type { Domain } from '../types/Domain';

export class DomainsApiService {
    private static base = `${API_BASE}/api/domains`;

    private static async authHeaders(): Promise<HeadersInit> {
        const token = await getAccessToken();
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        };
    }

    static async list(): Promise<Domain[]> {
        const res = await fetch(this.base, {
            headers: await this.authHeaders(),
        });
        if (!res.ok) throw new Error(`Failed to list domains: ${res.status}`);
        const json = await res.json();
        return json.data as Domain[];
    }

    static async create(name: string): Promise<{ id: string }> {
        const res = await fetch(this.base, {
            method: 'POST',
            headers: await this.authHeaders(),
            body: JSON.stringify({ name }),
        });
        if (!res.ok) throw new Error(`Failed to create domain: ${res.status}`);
        return res.json();
    }

    static async discover(): Promise<Domain[]> {
        const res = await fetch(`${this.base}/discover`, {
            headers: await this.authHeaders(),
        });
        if (!res.ok) throw new Error(`Failed to discover domains: ${res.status}`);
        const json = await res.json();
        return json.data as Domain[];
    }

    static async join(domainId: string): Promise<void> {
        const res = await fetch(`${this.base}/${domainId}/join`, {
            method: 'POST',
            headers: await this.authHeaders(),
        });
        if (!res.ok) throw new Error(`Failed to join domain: ${res.status}`);
    }
}
